var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneral03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26221 13.5V40.5M50.2622 32.625V40.5M50.2622 32.625H5.26221M50.2622 32.625H25.5122V18H46.8872C47.7823 18 48.6408 18.3556 49.2737 18.9885C49.9066 19.6214 50.2622 20.4799 50.2622 21.375V32.625Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3872 25.875C17.2512 25.875 18.7622 24.364 18.7622 22.5C18.7622 20.636 17.2512 19.125 15.3872 19.125C13.5232 19.125 12.0122 20.636 12.0122 22.5C12.0122 24.364 13.5232 25.875 15.3872 25.875Z",
    stroke: "#278DEC",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneral03);
export default __webpack_public_path__ + "static/media/general03.80f794c9f750800d3b49f441592cd31f.svg";
export { ForwardRef as ReactComponent };